export default __webpack_public_path__ + "i18n/translation-es.6fcb1de2.json";